import axios from "axios"

class UserInvoices {
    constructor(domElement = null) {
        this.container = $(domElement)
        if(!this.container.length) {
            console.error('Please provide proper DOM element for UserProfile/UserInvoices class')
            return
        }

        const { index } = this.container.data()
        const { invoicesRoute, translations } = window[`profile_invoices_${index}_data`]

        this.apiRoute = invoicesRoute
        this.translations = translations

        this.getUserData()
    }

    /**
     * Get user data
     */
    getUserData(user = null) {
        let userData = user
        if(!userData) {
            userData = localStorage.getItem('user_data')
                ? JSON.parse(localStorage.getItem('user_data'))
                : null
        }

        if (!userData) {
            return
        }

        const { userUuid } = userData
        if (userUuid) {
            this.fetchInvoices(userUuid)
        }
    }

    /**
     * Create Invoices table
     * @param {Array} tableData
     */
    createInvoicesTable(tableData = []) {
        const table = this.container.find('.invoices-table')

        let bodyMarkup
        if (tableData.length === 0) {
            bodyMarkup = `
                <tr>
                    <td colspan="4" class="p-4 no-results">
                        <p class="text-center subtitle-2">${this.translations.noResults}</p>
                    </td>
                </tr>
            `
        } else {
            bodyMarkup = tableData.map(item => {
                const { documentName, issueDate, en_invoice, rs_invoice } = item

                return `
                    <tr>
                        <td class="p-4">
                            ${documentName}
                        </td>
                        <td class="p-4">
                            ${issueDate || '&mdash;'}
                        </td>
                        <td class="p-4">
                            ${en_invoice ?
                                `
                                    <a href="${en_invoice}" download>
                                        ${this.translations.download}
                                    </a>
                                `
                                : '&mdash;'
                            }
                        </td>
                        <td class="p-4">
                            ${rs_invoice ?
                                `
                                    <a href="${rs_invoice}" download>
                                        ${this.translations.download}
                                    </a>
                                `
                                : '&mdash;'
                            }
                        </td>
                    </tr>
                `
            }).join(' ')
        }

        table.find('tbody').html(bodyMarkup)
    }

    /**
     * Fetch user invoices by uid
     * @param {String} userUuid
     */
    async fetchInvoices(userUuid = null) {
        try {
            const route = `${this.apiRoute}?uuid=${userUuid}`
            const response = await axios.get(route)

            const { data } = response

            this.createInvoicesTable(data)
        } catch(err) {
            console.error(err)
            throw err
        }
    }
}

export default UserInvoices
